import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import Link from "../../components/Link";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function GrafanaMeetup({ props }) {
    const { t } = useTranslation('common');
    const pageData = t('resources.events.pages.grafanaMeetup', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = pageData?.hero || {};
    const contentData = pageData?.content || {};
    const expectationsData = contentData?.expectations || {};
    const audienceData = contentData?.audience || {};
    const speakersData = contentData?.speakers || [];
    
    // Helper function to safely convert to string (handles objects)
    const safeString = (value: any): string => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            if (value.text) return String(value.text);
            if (value.value) return String(value.value);
            if (value.label) return String(value.label);
            return '';
        }
        return String(value);
    };
    
    return(
        <>
            <Layout isHomePage={false} pageTitle={String(pageData?.pageTitle ?? '')}
                    ogImage={String(pageData?.ogImage ?? '')}
                    uri={String(pageData?.uri ?? '')}
                    metaTitle={String(pageData?.metaTitle ?? '')}
                    metaDesc={String(pageData?.metaDesc ?? '')}
                    metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? '')}
                    metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? '')}>

                <div className={'global-wrapper'}>
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={String(heroData?.backLinkUrl ?? '/events/')} className={"back-to-blog"}>{String(heroData?.backLink ?? '')}</Link>
                                        {heroData?.logo && (
                                            <div className={'d-flex aws-mw'}>
                                                <img src={safeString(heroData.logo?.src)} alt={safeString(heroData.logo?.alt)} className={'aws-logo'} width={"100%"} height={"100%"}/>
                                            </div>
                                        )}
                                        <div className={'inner-hero'}>
                                            <h1>
                                                {safeString(heroData?.titlePrefix ?? '')}
                                                <span>{safeString(heroData?.titleHighlight ?? '')}</span>
                                                {safeString(heroData?.titleMiddle ?? '')}
                                                <span>{safeString(heroData?.titleHighlight2 ?? '')}</span>
                                                {safeString(heroData?.titleSuffix ?? '')}
                                            </h1>
                                            {heroData?.date && <p><b>Date: </b>{safeString(heroData.date)}</p>}
                                            {heroData?.time && <p><b>Time: </b>{safeString(heroData.time)}</p>}
                                            {heroData?.venue && <p><b>Venue: </b>{safeString(heroData.venue)}</p>}
                                        </div>
                                    </div>
                                    <div className={'right-block'}>
                                        <img
                                            src={String(heroData?.image?.src ?? '')} alt={String(heroData?.image?.alt ?? '')} width={"100%"} height={"100%"}/>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={'left-block '}>
                                    <p>{String(contentData?.description ?? '')}</p>
                                    
                                    {Array.isArray(contentData?.specialContent) && contentData.specialContent.map((content: string, index: number) => (
                                        <p key={index} dangerouslySetInnerHTML={{__html: String(content).replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></p>
                                    ))}

                                    {expectationsData?.title && (
                                        <>
                                            <h4>{String(expectationsData.title)}</h4>
                                            {Array.isArray(expectationsData?.items) && (
                                                <ul>
                                                    {expectationsData.items.map((item: string, index: number) => (
                                                        <li key={index}>{String(item)}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}

                                    {audienceData?.title && (
                                        <>
                                            <h4>{String(audienceData.title)}</h4>
                                            {Array.isArray(audienceData?.items) && (
                                                <ul>
                                                    {audienceData.items.map((item: string, index: number) => (
                                                        <li key={index}>{String(item)}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}

                                    {Array.isArray(speakersData) && speakersData.length > 0 && (
                                        <div className={"d-flex"}>
                                            {speakersData.map((speaker: any, index: number) => (
                                                <div key={index} className={"block"}>
                                                    {speaker?.image && (
                                                        <img src={String(speaker.image.src)} alt={String(speaker.image.alt)}/>
                                                    )}
                                                    <div className={"details"}>
                                                        <h4>{String(speaker?.name ?? '')}</h4>
                                                        <p>{String(speaker?.role ?? '')}</p>
                                                        {speaker?.linkedin && (
                                                            <Link href={String(speaker.linkedin)} target={"_blank"}>
                                                                <img src={"/images/blog/linkedin_event.svg"} alt={"event-linkedin"}/>
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>


                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
    return {
        props: {
            ...translations,
            pageTitle: "Grafana x Middleware Ahmedabad Meetup",
            description: "Middleware is proud to host Grafana for the Ahmedabad happy hour meetup on 9th September 2023 at Middleware's Ahmedabad office.",
            ogImage: "https://middleware.io/backend/wp-content/uploads/2023/08/meet-up-ahmedabad-social.png",
            uri: "/events/grafana-meetup/",
            metaTitle: "Grafana x Middleware Ahmedabad Meetup",
            metaDesc: "Middleware is proud to host Grafana for the Ahmedabad happy hour meetup on 9th September 2023 at Middleware's Ahmedabad office.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
    }
}
